import {
    sendPostRequest
} from "@/helper/requests";
import guard from "@/urls/roles/guard";

function get_domain(){
    /*
    *
     */
    if(process.env.VUE_APP_COOKIE_DOMAIN_PASSORDER !== undefined){
        return process.env.VUE_APP_COOKIE_DOMAIN_PASSORDER;
    }else{
        return null;
    }
}

function set_cookie_store_guard_hash(token) {
    /*
    * Заполняем кукисы
     */
    window.$cookies.remove("guard_hash", null, get_domain()); // удалим старый
    let date = new Date()
    date.setDate(date.getDate() + 1)
    date.setHours(3, 0, 0, 0)
    window.$cookies.set(
        "guard_hash",
        token,
        date.toUTCString(),
        null,
        get_domain(),
        null
    );
}

function set_cookie_store_guard_password(token) {
    /*
    * Заполняем кукисы
     */
    window.$cookies.remove("guard_password", null, get_domain()); // удалим старый
    let date = new Date()
    date.setDate(date.getDate() + 31)
    date.setHours(3, 0, 0, 0)
    window.$cookies.set(
        "guard_password",
        token,
        date.toUTCString(),
        null,
        get_domain(),
        null
    );
}
const state = {
    guard: {
        login: [],
        error: null
    }
}

const getters = {
    getGuardLogin: state => state.guard.login
}

const actions = {
    loginGuard: ({commit}, {data, finalizer, catcher}) => {
        let url =  guard.GUARD.LOGIN()
        if(data){
            let guard_password = data.password
            set_cookie_store_guard_password(guard_password)
            // set_cookie_store_guard_hash(null)
            // window.$cookies.set("guard_password", guard_password)
            sendPostRequest(
                url,
                data,
                finalizer ? finalizer : (data) => {
                    finalizer(data)
                },
                catcher ? catcher : () => {
                    commit("SAVE_GUARD_ERROR", data);
                    catcher(data);
                }
            )
        }
    }
}

const mutations = {
    SET_GUARD_LOGIN: (state, value) => {
        state.guard.login = value
    },
    SAVE_GUARD_ERROR: (state, error) => {
        state.guard.error = error
    }
}

export default {
    namespaced: false,
    state,
    mutations,
    actions,
    getters
}
